import { FormikValues } from 'formik';

import {
  getPublicProfessionalRatingItems,
  publicProfessionalRatingItems,
  publicRatePharmacist,
  PublicRatingType,
  utilActions,
} from '@pharmaplan/common';

import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';
import strings from '../../localization';

const usePublicRating = (
  _: PublicRatingType,
  ratingLevel: { [key: string]: number },
  bookingId: string,
  pharmacistId: string,
  pharmacyId: string,
) => {
  const dispatch = useAppDispatch();
  const pharmacistRatingItems = useAppSelector(publicProfessionalRatingItems);

  const handleSubmit = (values: FormikValues) => {
    const levels = pharmacistRatingItems?.pharmacistRatingItems?.map((item) => {
      const { pharmacistRatingItemId } = item ?? {};
      return {
        pharmacistRatingItemId,
        level: ratingLevel[pharmacistRatingItemId] ?? 0,
      };
    }) ?? [];

    const { comment } = values ?? {};

    dispatch(
      publicRatePharmacist({
        bookingId: bookingId ?? '',
        levels: [...levels],
        favorite: values?.favourite,
        comment,
        pharmacyId,
        pharmacistId,
      }),
    );
  };

  return {
    getAPI: getPublicProfessionalRatingItems,
    submitAPI: publicRatePharmacist,
    ratingItems: pharmacistRatingItems[
      'pharmacistRatingItems' as keyof typeof pharmacistRatingItems
    ] as any,
    ratingItemId: 'pharmacistRatingItemId',
    name: pharmacistRatingItems.pharmacistName,
    title: strings.myPharmacistRating,
    questions: [],
    questionsIdProperty: '',
    handleSubmit,
    maxRatedItemsPossible: pharmacistRatingItems?.pharmacistRatingItems?.length,
    successAction: utilActions.publicRatePharmacist,
    displayDetailForm: true,
  };
};

export default usePublicRating;
